import { StringSanitizer } from "./StringSanitizer";

const stringSanitizer = new StringSanitizer();

export function isFormDisabled(actievePublisher: any, publStatus: string, metaStatus: string): boolean {
  if (!actievePublisher) return true;
  const sanitizedMeta = stringSanitizer.sanitizePublicatieStatus(metaStatus);
  const sanitizedPubl = stringSanitizer.sanitizePublicatieStatus(publStatus);
  return (
    sanitizedMeta === "Ingetrokken" ||
    sanitizedPubl === "Ingetrokken" ||
    sanitizedMeta === "Pending" ||
    sanitizedPubl === "Pending"
  );
}

export function isDpcHoofdDoc(pid?: string): boolean {
  if (!pid) return false;
  return stringSanitizer.extractIdentifierFromPid(pid).startsWith("dpc-");
}
